import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import { type APIResponse, type IncidentType } from "@/lib/types";

export const createIncidentTypeV1 = (data: Partial<IncidentType>) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<IncidentType>
    >(`${baseFastApiMatterRoute}/incident-types`, data)
    .then((res) => res.data);
};

export const updateIncidentTypeV1 = (
  data: Pick<IncidentType, "id" | "dateModified"> & Partial<IncidentType>,
) => {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<IncidentType>
    >(`${baseFastApiMatterRoute}/incident-types`, data)
    .then((res) => res.data);
};

export const deleteIncidentTypeV1 = (data: { id: string }) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<IncidentType>
    >(`${baseFastApiMatterRoute}/incident-types/${id}`)
    .then((res) => res.data);
};
